import { BehaviorSubject, Observable } from 'rxjs'
import {
    ApplicationSettings,
    CarefinityRoles,
    LoginRespose,
    Practice,
    PracticeSettings,
} from '../../api/models'
import { AppSettingService, AuthService } from '../../api/services'
import { Guid } from '../../helpers/Guid'
export class CareFinitySession {
    public static practice: BehaviorSubject<Practice> =
        new BehaviorSubject<Practice>({})

    private static _applicationSettings: ApplicationSettings
    private static _practiceSettings: PracticeSettings

    public static loadAppSettings(settings: ApplicationSettings) {
        this._applicationSettings = settings
        this.setLocalItem('applicationSettings', JSON.stringify(settings))
        this.setLocalItem('isImportSettings', this._applicationSettings?.isImportSettings == true ? 'true' : 'false');



    }

    public static login(res: LoginRespose) {
        let user = this.user
        user.userID = res.userId
        user.name = res.userFullName
        user.userName = res.userName
        user.mfaRequired = res.mfa
        user.forcePasswordChange = res.forcePasswordChange;

        if (res.token) {

            const JwtPayload = this.decodeJwtPayload(res.token);
            const Privileges: any[] = JwtPayload?.Privilege ?? [];
            const roles = Privileges.reduce((acc, curr) => {
                acc[curr.charAt(0).toLowerCase() + curr.slice(1)] = true
                return acc;
            }, {});


            user.roles = roles;
        }
        this.setLocalItem('CF_Session_user', JSON.stringify(user));
        this.setLocalItem('CF_Session_token', res.token);
        this.setLocalItem('CF_Session_sessionID', res.sessionID);
        this.setLocalItem('EnterpriseID', res.enterpriseID);
        this.setLocalItem('IsPNearExpiry', res.isPasswordNearExpiry == true ? 'true' : 'false');
        this.setLocalItem('PNearExpirMessage', res.passwordNearExpirMessage);
    }

    private static decodeJwtPayload(token: string) {
        let base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const pad = base64.length % 4;
        if (pad) base64 += '='.repeat(4 - pad);
        return JSON.parse(atob(base64));
    }

    public static setUserRole(role: CarefinityRoles) {
        let user = this.user
        user.roles = role
        this.setLocalItem('CF_Session_user', JSON.stringify(user))
    }
    public static get applicationSettings(): ApplicationSettings {
        if (this._applicationSettings) return this._applicationSettings

        let item = this.getLocalItem('applicationSettings')
        if (item) return JSON.parse(item)
        return {}
    }

    public static get practiceSettings(): PracticeSettings {
        if (this._practiceSettings) return this._practiceSettings

        let item = this.getLocalItem('practiceSettings')
        if (item) return JSON.parse(item)
    }

    public static get userPractices(): Array<Practice> {
        let item = this.getLocalItem('user_practices')
        if (item) return JSON.parse(item)
        else {
            return new Array<Practice>()
        }
    }
    public static enterpriseID(): string {
        let item = this.getLocalItem('EnterpriseID')
        return item
    }

    public static updateToken(token: string) {
        this.setLocalItem('CF_Session_token', token)
    }

    public static get user(): SessionUser {
        let item = this.getLocalItem('CF_Session_user')
        if (item) return JSON.parse(item)
        else {
            return new SessionUser()
        }
    }

    public static logout(authService: AuthService) {

        console.log('session context logout ' + window.location)

        if (this.sessionID && this.token) {
           
        }
        authService.authRevokeSession({ sessionID: this.sessionID }).subscribe({
            next: (res) => {
                console.log('session context logout next');
            },
            error: (err) => {
                console.log('Error while revoking session on server ' + err)
            }
        });
        console.log('session context  localStorage.clear()');
        localStorage.clear()
        console.log('session context  localStorage.clear() done');
    }

    public static selectPractice(practice: Practice, settings: PracticeSettings) {
        //When ever there is change in practice make sure we reload user role
        //this.setUserRole(null)
        this.practice.next(practice)

        // Moved this code to class but these are used at multiple places so let us set to local storage for now.

        if (practice) {
            localStorage.setItem('EmrPracticeId', practice.emrPracticeId)
            localStorage.setItem('PracticeId', practice.practiceid)
            localStorage.setItem('DefaultProviderId', practice.defaultProviderId)
            localStorage.setItem('DefaultProviderName', practice.defaultProviderName)
        } else {
            localStorage.setItem('EmrPracticeId', '')
            localStorage.setItem('PracticeId', '')
            localStorage.setItem('DefaultProviderId', '')
            localStorage.setItem('DefaultProviderName', '')
        }

        this._practiceSettings = settings
        this.setLocalItem(
            'practiceSettings',
            JSON.stringify(this._practiceSettings),
        )
    }

    public static get sessionID(): string {
        return this.getLocalItem('CF_Session_sessionID')
    }
    public static get isActive(): boolean {
        return this.token ? true : false
    }
    public static get token(): string {
        let item = this.getLocalItem('CF_Session_token')
        return item
    }
    public static get lastUserActivity(): number {
        let item = this.getSessionItem('CF_Session_lastUserActivity')
        return parseInt('0' + item)
    }

    public static set lastUserActivity(val: number) {
        this.setSessionItem('CF_Session_lastUserActivity', val.toString())
    }

    public static get isSAMLSession(): boolean {
        return this.getLocalItem('CF_Session_isSAMLSession') == 'true'
    }

    public static set isSAMLSession(val: boolean) {
        this.setLocalItem('CF_Session_isSAMLSession', val.toString())
    }

    public static get showPatientBanner(): boolean {
        if (!CareFinitySession.isSAMLSession) return true
        return this.getLocalItem('CF_Session_showPatientBanner') == 'true'
    }

    public static set showPatientBanner(val: boolean) {
        this.setLocalItem('CF_Session_showPatientBanner', val.toString())
    }

    public static get showOnlyPatientNavigations(): boolean {
        if (!CareFinitySession.isSAMLSession) return false
        return this.getLocalItem('CF_Session_showOnlyPatientNavigations') == 'true'
    }

    public static set showOnlyPatientNavigations(val: boolean) {
        this.setLocalItem('CF_Session_showOnlyPatientNavigations', val.toString())
    }

    public static getSessionItem(key: string): string {
        let item = sessionStorage.getItem(key)

        if (item) item = this.decode(item)
        return item
    }

    public static setLocalItem(key: string, value: string): void {
        localStorage.setItem(key, this.encode(value))
    }

    public static getLocalItem(key: string): string {
        let item = localStorage.getItem(key)
        if (item) item = this.decode(item)
        return item
    }

    public static setSessionItem(key: string, value: string): void {
        sessionStorage.setItem(key, this.encode(value))
    }

    public static get deviceID(): string {
        let item = this.getLocalItem('CF_Session_deviceID')
        if (!item) {
            item = Guid.newGuid().toString()
            this.setLocalItem('CF_Session_deviceID', item)
        }
        return item
    }

    //private static secretKey = 'dj6@#$dl98*()=!F';

    //private static mess(data: string): string {
    //    let result = '';
    //    for (let i = 0; i < data.length; i++) {
    //        result += String.fromCharCode(data.charCodeAt(i) ^ this.secretKey.charCodeAt(i % this.secretKey.length));
    //    }
    //    return result;
    //}

    private static encode(data: string): string {
        return data
        //return btoa(this.mess(data));
    }

    private static decode(encodedData: string): string {
        return encodedData
        // return this.mess(atob(encodedData));
    }
}

export class SessionUser {
    userID = 0
    userName = ''
    name = ''
    mfaDone = false
    mfaRequired = false
    forcePasswordChange = false
    roles: CarefinityRoles
}
